import script from "./PopupTool4.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool4.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool4.vue?vue&type=style&index=0&id=279c8776&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/u.xiansuotu.com/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279c8776"]])

export default __exports__